"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.totalTimeLogInTranslations = {
    "en": {
        totalTimeLoggedInSince: "Total Time logged in (Since",
        totalTimeLoggedIn: "Total Time logged in",
        infoText: "The total time this Agent was logged into an Advanced Hunt Group per day.",
    },
    "de": {
        infoText: "Die Gesamtzeit, die dieser Agent pro Tag bei einer erweiterten Sammelrufgruppe angemeldet war.",
        totalTimeLoggedIn: "Gesamte eingeloggte Zeit",
        totalTimeLoggedInSince: "Gesamte eingeloggte Zeit (seit ",
    },
    "nl": {
        infoText: "De totale tijd per dag waarop deze Agent was ingelogd op een Geavanceerde Belgroep.",
        totalTimeLoggedIn: "Totale tijd ingelogd",
        totalTimeLoggedInSince: "Totale tijd ingelogd (sinds ",
    },
    "it": {
        infoText: "Il tempo totale giornaliero di connessione ad un Gruppo di ricerca avanzato di questo Agente.",
        totalTimeLoggedIn: "Tempo totale di accesso",
        totalTimeLoggedInSince: "Tempo totale di accesso (da ",
    },
    "fr": {
        infoText: "Le temps total journalier pendant lequel cet agent a été connecté à un Groupe de recherche avancé.",
        totalTimeLoggedIn: "Temps total de connexion",
        totalTimeLoggedInSince: "Temps total de connexion (depuis ",
    },
    "es": {
        infoText: "El tiempo total que este Agente estuvo conectado a un Grupo de Línea colectiva Avanzado por día.",
        totalTimeLoggedIn: "Tiempo total que estuvo conectado",
        totalTimeLoggedInSince: "Tiempo total que estuvo conectado (Desde ",
    },
    "ja": {
        infoText: "このエージェントが1日のうちアドバンストハントグループにログインした時間の合計です。",
        totalTimeLoggedIn: "合計ログイン時間",
        totalTimeLoggedInSince: "合計ログイン時間（開始日時： ",
    },
    "en-GB": {
        infoText: "The total time this Agent was logged into an Advanced Hunt Group per day.",
        totalTimeLoggedIn: "Total Time logged in",
        totalTimeLoggedInSince: "Total Time logged in (Since ",
    },
    "ru": {
        totalTimeLoggedInSince: "Общее Время Онлайн(С",
        totalTimeLoggedIn: "Общее Время Онлайн",
        infoText: "The total time this Agent was logged into an Advanced Hunt Group per day.",
    },
};
